import enumPart from './enumPart';

// util
import objectHelper from '../util/objectHelper';

let e = objectHelper.merge(enumPart, {

    CHOICENESS_DATUM_MODULE: {
        code: 1,
        title: '精选资料模块'
    }

});

export default e;
